import axios from 'axios'
import { BUSCAR_CIDADES } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarCidades (filtros, pagina, registrosPorPagina) {
  let url = `${URL}/public/cidades?size=${registrosPorPagina}&from=${pagina}`;
  if (filtros.nome) {
    url = `${url}&nome=${filtros.nome}`
  }
  if (filtros.uf) {
    url = `${url}&uf=${filtros.uf}`
  }
  if (filtros.id) {
    url = `${url}&id=${filtros.id}`
  }
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_CIDADES,
        payload: response

      })
  );
}
